// extracted by mini-css-extract-plugin
export default {"header":"sectionHeader_header__llAwe","headerMain":"sectionHeader_headerMain__xHCCj","title":"sectionHeader_title__B05Y8"};